import { render, staticRenderFns } from "./Manage_website.vue?vue&type=template&id=9f556a46&scoped=true&"
import script from "./Manage_website.vue?vue&type=script&lang=js&"
export * from "./Manage_website.vue?vue&type=script&lang=js&"
import style0 from "./Manage_website.vue?vue&type=style&index=0&id=9f556a46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f556a46",
  null
  
)

export default component.exports